module.exports = __webpack_public_path__ + "img/Course-head.503642a2.jpg";